export const icomoonList = [
  { icon: 'icon-home', free: true },
  { icon: 'icon-home2', free: true },
  { icon: 'icon-home3', free: true },
  { icon: 'icon-home4' },
  { icon: 'icon-home5' },
  { icon: 'icon-home6' },
  { icon: 'icon-home7' },
  { icon: 'icon-home8' },
  { icon: 'icon-home9' },
  { icon: 'icon-office', free: true },
  { icon: 'icon-city' },
  { icon: 'icon-newspaper', free: true },
  { icon: 'icon-magazine' },
  { icon: 'icon-design' },
  { icon: 'icon-pencil', free: true },
  { icon: 'icon-pencil2', free: true },
  { icon: 'icon-pencil3' },
  { icon: 'icon-pencil4' },
  { icon: 'icon-pencil5' },
  { icon: 'icon-pencil6' },
  { icon: 'icon-pencil7' },
  { icon: 'icon-eraser' },
  { icon: 'icon-eraser2' },
  { icon: 'icon-eraser3' },
  { icon: 'icon-quill', free: true },
  { icon: 'icon-quill2' },
  { icon: 'icon-quill3' },
  { icon: 'icon-quill4' },
  { icon: 'icon-pen', free: true },
  { icon: 'icon-pen-plus' },
  { icon: 'icon-pen-minus' },
  { icon: 'icon-pen2' },
  { icon: 'icon-pen3' },
  { icon: 'icon-pen4' },
  { icon: 'icon-pen5' },
  { icon: 'icon-marker' },
  { icon: 'icon-marker2' },
  { icon: 'icon-blog', free: true },
  { icon: 'icon-blog2' },
  { icon: 'icon-pen6' },
  { icon: 'icon-brush' },
  { icon: 'icon-spray' },
  { icon: 'icon-palette' },
  { icon: 'icon-palette2' },
  { icon: 'icon-color-sampler' },
  { icon: 'icon-toggle' },
  { icon: 'icon-bucket' },
  { icon: 'icon-bucket2' },
  { icon: 'icon-gradient' },
  { icon: 'icon-eyedropper', free: true },
  { icon: 'icon-eyedropper2' },
  { icon: 'icon-eyedropper3' },
  { icon: 'icon-droplet', free: true },
  { icon: 'icon-droplet2' },
  { icon: 'icon-droplet-contrast' },
  { icon: 'icon-color-clear' },
  { icon: 'icon-paint-format', free: true },
  { icon: 'icon-stamp' },
  { icon: 'icon-images', free: true },
  { icon: 'icon-image', free: true },
  { icon: 'icon-image2' },
  { icon: 'icon-image-compare' },
  { icon: 'icon-images2' },
  { icon: 'icon-image3' },
  { icon: 'icon-images3' },
  { icon: 'icon-image4' },
  { icon: 'icon-image5' },
  { icon: 'icon-image6' },
  { icon: 'icon-camera', free: true },
  { icon: 'icon-camera2' },
  { icon: 'icon-camera3' },
  { icon: 'icon-shutter' },
  { icon: 'icon-headphones', free: true },
  { icon: 'icon-headset' },
  { icon: 'icon-music', free: true },
  { icon: 'icon-music2' },
  { icon: 'icon-music3' },
  { icon: 'icon-music4' },
  { icon: 'icon-music5' },
  { icon: 'icon-music6' },
  { icon: 'icon-album' },
  { icon: 'icon-cassette' },
  { icon: 'icon-tape' },
  { icon: 'icon-piano' },
  { icon: 'icon-guitar' },
  { icon: 'icon-trumpet' },
  { icon: 'icon-speakers' },
  { icon: 'icon-play', free: true },
  { icon: 'icon-play2', free: true },
  { icon: 'icon-clapboard-play' },
  { icon: 'icon-clapboard' },
  { icon: 'icon-media' },
  { icon: 'icon-presentation' },
  { icon: 'icon-movie' },
  { icon: 'icon-film', free: true },
  { icon: 'icon-film2' },
  { icon: 'icon-film3' },
  { icon: 'icon-film4' },
  { icon: 'icon-video-camera', free: true },
  { icon: 'icon-video-camera2' },
  { icon: 'icon-video-camera-slash' },
  { icon: 'icon-video-camera3' },
  { icon: 'icon-video-camera4' },
  { icon: 'icon-video-camera-slash2' },
  { icon: 'icon-video-camera5' },
  { icon: 'icon-recording' },
  { icon: 'icon-dice', free: true },
  { icon: 'icon-gamepad' },
  { icon: 'icon-gamepad2' },
  { icon: 'icon-gamepad3' },
  { icon: 'icon-pacman', free: true },
  { icon: 'icon-spades', free: true },
  { icon: 'icon-clubs', free: true },
  { icon: 'icon-diamonds', free: true },
  { icon: 'icon-chess-king' },
  { icon: 'icon-chess-queen' },
  { icon: 'icon-chess-rook' },
  { icon: 'icon-chess-bishop' },
  { icon: 'icon-chess-knight' },
  { icon: 'icon-chess-pawn' },
  { icon: 'icon-chess' },
  { icon: 'icon-bullhorn', free: true },
  { icon: 'icon-megaphone' },
  { icon: 'icon-new' },
  { icon: 'icon-connection', free: true },
  { icon: 'icon-connection2' },
  { icon: 'icon-connection3' },
  { icon: 'icon-connection4' },
  { icon: 'icon-podcast', free: true },
  { icon: 'icon-station' },
  { icon: 'icon-station2' },
  { icon: 'icon-antenna' },
  { icon: 'icon-satellite-dish' },
  { icon: 'icon-satellite-dish2' },
  { icon: 'icon-feed', free: true },
  { icon: 'icon-podcast2' },
  { icon: 'icon-antenna2' },
  { icon: 'icon-mic', free: true },
  { icon: 'icon-mic-off' },
  { icon: 'icon-mic2' },
  { icon: 'icon-mic-off2' },
  { icon: 'icon-mic3' },
  { icon: 'icon-mic4' },
  { icon: 'icon-mic5' },
  { icon: 'icon-book', free: true },
  { icon: 'icon-book2' },
  { icon: 'icon-book-play' },
  { icon: 'icon-book3' },
  { icon: 'icon-bookmark', free: true },
  { icon: 'icon-books', free: true },
  { icon: 'icon-archive' },
  { icon: 'icon-reading' },
  { icon: 'icon-library', free: true },
  { icon: 'icon-library2' },
  { icon: 'icon-graduation' },
  { icon: 'icon-file-text', free: true },
  { icon: 'icon-profile', free: true },
  { icon: 'icon-file-empty', free: true },
  { icon: 'icon-file-empty2' },
  { icon: 'icon-files-empty', free: true },
  { icon: 'icon-files-empty2' },
  { icon: 'icon-file-plus' },
  { icon: 'icon-file-plus2' },
  { icon: 'icon-file-minus' },
  { icon: 'icon-file-minus2' },
  { icon: 'icon-file-download' },
  { icon: 'icon-file-download2' },
  { icon: 'icon-file-upload' },
  { icon: 'icon-file-upload2' },
  { icon: 'icon-file-check' },
  { icon: 'icon-file-check2' },
  { icon: 'icon-file-eye' },
  { icon: 'icon-file-eye2' },
  { icon: 'icon-file-text2', free: true },
  { icon: 'icon-file-text3' },
  { icon: 'icon-file-picture', free: true },
  { icon: 'icon-file-picture2' },
  { icon: 'icon-file-music', free: true },
  { icon: 'icon-file-music2' },
  { icon: 'icon-file-play', free: true },
  { icon: 'icon-file-play2' },
  { icon: 'icon-file-video', free: true },
  { icon: 'icon-file-video2' },
  { icon: 'icon-copy', free: true },
  { icon: 'icon-copy2' },
  { icon: 'icon-file-zip', free: true },
  { icon: 'icon-file-zip2' },
  { icon: 'icon-file-xml' },
  { icon: 'icon-file-xml2' },
  { icon: 'icon-file-css' },
  { icon: 'icon-file-css2' },
  { icon: 'icon-file-presentation' },
  { icon: 'icon-file-presentation2' },
  { icon: 'icon-file-stats' },
  { icon: 'icon-file-stats2' },
  { icon: 'icon-file-locked' },
  { icon: 'icon-file-locked2' },
  { icon: 'icon-file-spreadsheet' },
  { icon: 'icon-file-spreadsheet2' },
  { icon: 'icon-copy3' },
  { icon: 'icon-copy4' },
  { icon: 'icon-paste', free: true },
  { icon: 'icon-paste2' },
  { icon: 'icon-paste3' },
  { icon: 'icon-paste4' },
  { icon: 'icon-stack', free: true },
  { icon: 'icon-stack2' },
  { icon: 'icon-stack3' },
  { icon: 'icon-folder', free: true },
  { icon: 'icon-folder-search' },
  { icon: 'icon-folder-download', free: true },
  { icon: 'icon-folder-upload', free: true },
  { icon: 'icon-folder-plus', free: true },
  { icon: 'icon-folder-plus2' },
  { icon: 'icon-folder-minus', free: true },
  { icon: 'icon-folder-minus2' },
  { icon: 'icon-folder-check' },
  { icon: 'icon-folder-heart' },
  { icon: 'icon-folder-remove' },
  { icon: 'icon-folder2' },
  { icon: 'icon-folder-open', free: true },
  { icon: 'icon-folder3' },
  { icon: 'icon-folder4' },
  { icon: 'icon-folder-plus3' },
  { icon: 'icon-folder-minus3' },
  { icon: 'icon-folder-plus4' },
  { icon: 'icon-folder-minus4' },
  { icon: 'icon-folder-download2' },
  { icon: 'icon-folder-upload2' },
  { icon: 'icon-folder-download3' },
  { icon: 'icon-folder-upload3' },
  { icon: 'icon-folder5' },
  { icon: 'icon-folder-open2' },
  { icon: 'icon-folder6' },
  { icon: 'icon-folder-open3' },
  { icon: 'icon-certificate' },
  { icon: 'icon-cc' },
  { icon: 'icon-price-tag', free: true },
  { icon: 'icon-price-tag2' },
  { icon: 'icon-price-tags', free: true },
  { icon: 'icon-price-tag3' },
  { icon: 'icon-price-tags2' },
  { icon: 'icon-price-tag4' },
  { icon: 'icon-price-tags3' },
  { icon: 'icon-price-tag5' },
  { icon: 'icon-price-tags4' },
  { icon: 'icon-barcode', free: true },
  { icon: 'icon-barcode2' },
  { icon: 'icon-qrcode', free: true },
  { icon: 'icon-ticket', free: true },
  { icon: 'icon-ticket2' },
  { icon: 'icon-theater' },
  { icon: 'icon-store' },
  { icon: 'icon-store2' },
  { icon: 'icon-cart', free: true },
  { icon: 'icon-cart2' },
  { icon: 'icon-cart3' },
  { icon: 'icon-cart4' },
  { icon: 'icon-cart5' },
  { icon: 'icon-cart-add' },
  { icon: 'icon-cart-add2' },
  { icon: 'icon-cart-remove' },
  { icon: 'icon-basket' },
  { icon: 'icon-bag' },
  { icon: 'icon-bag2' },
  { icon: 'icon-percent' },
  { icon: 'icon-coins' },
  { icon: 'icon-coin-dollar', free: true },
  { icon: 'icon-coin-euro', free: true },
  { icon: 'icon-coin-pound', free: true },
  { icon: 'icon-coin-yen', free: true },
  { icon: 'icon-piggy-bank' },
  { icon: 'icon-wallet' },
  { icon: 'icon-cash' },
  { icon: 'icon-cash2' },
  { icon: 'icon-cash3' },
  { icon: 'icon-cash4' },
  { icon: 'icon-credit-card', free: true },
  { icon: 'icon-credit-card2' },
  { icon: 'icon-calculator', free: true },
  { icon: 'icon-calculator2' },
  { icon: 'icon-calculator3' },
  { icon: 'icon-chip' },
  { icon: 'icon-lifebuoy', free: true },
  { icon: 'icon-phone', free: true },
  { icon: 'icon-phone2' },
  { icon: 'icon-phone-slash' },
  { icon: 'icon-phone-wave' },
  { icon: 'icon-phone-plus' },
  { icon: 'icon-phone-minus' },
  { icon: 'icon-phone-plus2' },
  { icon: 'icon-phone-minus2' },
  { icon: 'icon-phone-incoming' },
  { icon: 'icon-phone-outgoing' },
  { icon: 'icon-phone3' },
  { icon: 'icon-phone-slash2' },
  { icon: 'icon-phone-wave2' },
  { icon: 'icon-phone-hang-up', free: true },
  { icon: 'icon-phone-hang-up2' },
  { icon: 'icon-address-book', free: true },
  { icon: 'icon-address-book2' },
  { icon: 'icon-address-book3' },
  { icon: 'icon-notebook' },
  { icon: 'icon-at-sign' },
  { icon: 'icon-envelop', free: true },
  { icon: 'icon-envelop2' },
  { icon: 'icon-envelop3' },
  { icon: 'icon-envelop4' },
  { icon: 'icon-envelop5' },
  { icon: 'icon-mailbox' },
  { icon: 'icon-pushpin', free: true },
  { icon: 'icon-pushpin2' },
  { icon: 'icon-location', free: true },
  { icon: 'icon-location2', free: true },
  { icon: 'icon-location3' },
  { icon: 'icon-location4' },
  { icon: 'icon-location5' },
  { icon: 'icon-location6' },
  { icon: 'icon-location7' },
  { icon: 'icon-compass', free: true },
  { icon: 'icon-compass2', free: true },
  { icon: 'icon-compass3' },
  { icon: 'icon-compass4' },
  { icon: 'icon-compass5' },
  { icon: 'icon-compass6' },
  { icon: 'icon-map', free: true },
  { icon: 'icon-map2', free: true },
  { icon: 'icon-map3' },
  { icon: 'icon-map4' },
  { icon: 'icon-map5' },
  { icon: 'icon-direction' },
  { icon: 'icon-reset' },
  { icon: 'icon-history', free: true },
  { icon: 'icon-clock', free: true },
  { icon: 'icon-clock2', free: true },
  { icon: 'icon-clock3' },
  { icon: 'icon-clock4' },
  { icon: 'icon-watch' },
  { icon: 'icon-watch2' },
  { icon: 'icon-alarm', free: true },
  { icon: 'icon-alarm-add' },
  { icon: 'icon-alarm-check' },
  { icon: 'icon-alarm-cancel' },
  { icon: 'icon-bell', free: true },
  { icon: 'icon-bell2' },
  { icon: 'icon-bell3' },
  { icon: 'icon-bell-plus' },
  { icon: 'icon-bell-minus' },
  { icon: 'icon-bell-check' },
  { icon: 'icon-bell-cross' },
  { icon: 'icon-stopwatch', free: true },
  { icon: 'icon-calendar', free: true },
  { icon: 'icon-calendar2' },
  { icon: 'icon-calendar3' },
  { icon: 'icon-calendar4' },
  { icon: 'icon-calendar5' },
  { icon: 'icon-calendar-empty' },
  { icon: 'icon-calendar-day' },
  { icon: 'icon-calendar-week' },
  { icon: 'icon-printer', free: true },
  { icon: 'icon-printer2' },
  { icon: 'icon-printer3' },
  { icon: 'icon-printer4' },
  { icon: 'icon-shredder' },
  { icon: 'icon-mouse' },
  { icon: 'icon-mouse2' },
  { icon: 'icon-mouse-left' },
  { icon: 'icon-mouse-right' },
  { icon: 'icon-keyboard', free: true },
  { icon: 'icon-keyboard2' },
  { icon: 'icon-typewriter' },
  { icon: 'icon-display', free: true },
  { icon: 'icon-display2' },
  { icon: 'icon-display3' },
  { icon: 'icon-display4' },
  { icon: 'icon-laptop', free: true },
  { icon: 'icon-mobile', free: true },
  { icon: 'icon-mobile2', free: true },
  { icon: 'icon-tablet', free: true },
  { icon: 'icon-mobile3' },
  { icon: 'icon-tv', free: true },
  { icon: 'icon-radio' },
  { icon: 'icon-cabinet' },
  { icon: 'icon-drawer', free: true },
  { icon: 'icon-drawer2', free: true },
  { icon: 'icon-drawer-out' },
  { icon: 'icon-drawer-in' },
  { icon: 'icon-drawer3' },
  { icon: 'icon-box' },
  { icon: 'icon-box-add', free: true },
  { icon: 'icon-box-remove', free: true },
  { icon: 'icon-download', free: true },
  { icon: 'icon-upload', free: true },
  { icon: 'icon-floppy-disk', free: true },
  { icon: 'icon-floppy-disks' },
  { icon: 'icon-floppy-disks2' },
  { icon: 'icon-floppy-disk2' },
  { icon: 'icon-floppy-disk3' },
  { icon: 'icon-disk' },
  { icon: 'icon-disk2' },
  { icon: 'icon-usb-stick' },
  { icon: 'icon-drive', free: true },
  { icon: 'icon-server' },
  { icon: 'icon-database', free: true },
  { icon: 'icon-database2' },
  { icon: 'icon-database3' },
  { icon: 'icon-database4' },
  { icon: 'icon-database-menu' },
  { icon: 'icon-database-add' },
  { icon: 'icon-database-remove' },
  { icon: 'icon-database-insert' },
  { icon: 'icon-database-export' },
  { icon: 'icon-database-upload' },
  { icon: 'icon-database-refresh' },
  { icon: 'icon-database-diff' },
  { icon: 'icon-database-edit' },
  { icon: 'icon-database-edit2' },
  { icon: 'icon-database-check' },
  { icon: 'icon-database-arrow' },
  { icon: 'icon-database-time' },
  { icon: 'icon-database-time2' },
  { icon: 'icon-undo', free: true },
  { icon: 'icon-redo', free: true },
  { icon: 'icon-rotate-ccw' },
  { icon: 'icon-rotate-cw' },
  { icon: 'icon-rotate-ccw2' },
  { icon: 'icon-rotate-cw2' },
  { icon: 'icon-rotate-ccw3' },
  { icon: 'icon-rotate-cw3' },
  { icon: 'icon-flip-vertical' },
  { icon: 'icon-flip-vertical2' },
  { icon: 'icon-flip-horizontal' },
  { icon: 'icon-flip-horizontal2' },
  { icon: 'icon-flip-vertical3' },
  { icon: 'icon-flip-vertical4' },
  { icon: 'icon-angle' },
  { icon: 'icon-shear' },
  { icon: 'icon-unite' },
  { icon: 'icon-subtract' },
  { icon: 'icon-interset' },
  { icon: 'icon-exclude' },
  { icon: 'icon-align-left' },
  { icon: 'icon-align-center-horizontal' },
  { icon: 'icon-align-right' },
  { icon: 'icon-align-top' },
  { icon: 'icon-align-center-vertical' },
  { icon: 'icon-align-bottom' },
  { icon: 'icon-undo2', free: true },
  { icon: 'icon-redo2', free: true },
  { icon: 'icon-forward', free: true },
  { icon: 'icon-reply', free: true },
  { icon: 'icon-reply-all' },
  { icon: 'icon-bubble', free: true },
  { icon: 'icon-bubbles', free: true },
  { icon: 'icon-bubbles2', free: true },
  { icon: 'icon-bubble2', free: true },
  { icon: 'icon-bubbles3', free: true },
  { icon: 'icon-bubbles4', free: true },
  { icon: 'icon-bubble-notification' },
  { icon: 'icon-bubbles5' },
  { icon: 'icon-bubbles6' },
  { icon: 'icon-bubble3' },
  { icon: 'icon-bubble-dots' },
  { icon: 'icon-bubble-lines' },
  { icon: 'icon-bubble4' },
  { icon: 'icon-bubble-dots2' },
  { icon: 'icon-bubble-lines2' },
  { icon: 'icon-bubble5' },
  { icon: 'icon-bubble6' },
  { icon: 'icon-bubbles7' },
  { icon: 'icon-bubble7' },
  { icon: 'icon-bubbles8' },
  { icon: 'icon-bubble8' },
  { icon: 'icon-bubble-dots3' },
  { icon: 'icon-bubble-lines3' },
  { icon: 'icon-bubble9' },
  { icon: 'icon-bubble-dots4' },
  { icon: 'icon-bubble-lines4' },
  { icon: 'icon-bubbles9' },
  { icon: 'icon-bubbles10' },
  { icon: 'icon-bubble-blocked' },
  { icon: 'icon-bubble-quote' },
  { icon: 'icon-bubble-user' },
  { icon: 'icon-bubble-smiley' },
  { icon: 'icon-bubble-check' },
  { icon: 'icon-bubble-video' },
  { icon: 'icon-bubble-link' },
  { icon: 'icon-bubble-lock' },
  { icon: 'icon-bubble-star' },
  { icon: 'icon-bubble-heart' },
  { icon: 'icon-bubble-paperclip' },
  { icon: 'icon-bubble-cancel' },
  { icon: 'icon-bubble-plus' },
  { icon: 'icon-bubble-minus' },
  { icon: 'icon-bubble-notification2' },
  { icon: 'icon-bubble-left' },
  { icon: 'icon-bubble-right' },
  { icon: 'icon-bubble-first' },
  { icon: 'icon-bubble-last' },
  { icon: 'icon-bubble-reply' },
  { icon: 'icon-bubble-forward' },
  { icon: 'icon-bubble-reply2' },
  { icon: 'icon-bubble-forward2' },
  { icon: 'icon-user', free: true },
  { icon: 'icon-users', free: true },
  { icon: 'icon-user-plus', free: true },
  { icon: 'icon-user-minus', free: true },
  { icon: 'icon-user-cancel' },
  { icon: 'icon-user-block' },
  { icon: 'icon-user-lock' },
  { icon: 'icon-user-check', free: true },
  { icon: 'icon-users2' },
  { icon: 'icon-user2' },
  { icon: 'icon-users3' },
  { icon: 'icon-user-plus2' },
  { icon: 'icon-user-minus2' },
  { icon: 'icon-user-cancel2' },
  { icon: 'icon-user-block2' },
  { icon: 'icon-user-lock2' },
  { icon: 'icon-user-check2' },
  { icon: 'icon-user3' },
  { icon: 'icon-user4' },
  { icon: 'icon-user5' },
  { icon: 'icon-user6' },
  { icon: 'icon-users4' },
  { icon: 'icon-user-tie', free: true },
  { icon: 'icon-user7' },
  { icon: 'icon-users5' },
  { icon: 'icon-collaboration' },
  { icon: 'icon-vcard' },
  { icon: 'icon-hat' },
  { icon: 'icon-bowtie' },
  { icon: 'icon-tie' },
  { icon: 'icon-hanger' },
  { icon: 'icon-tshirt' },
  { icon: 'icon-pants' },
  { icon: 'icon-shorts' },
  { icon: 'icon-sock' },
  { icon: 'icon-laundry' },
  { icon: 'icon-quotes-left', free: true },
  { icon: 'icon-quotes-right', free: true },
  { icon: 'icon-quotes-left2' },
  { icon: 'icon-quotes-right2' },
  { icon: 'icon-hour-glass', free: true },
  { icon: 'icon-hour-glass2' },
  { icon: 'icon-hour-glass3' },
  { icon: 'icon-spinner', free: true },
  { icon: 'icon-spinner2', free: true },
  { icon: 'icon-spinner3', free: true },
  { icon: 'icon-spinner4', free: true },
  { icon: 'icon-spinner5', free: true },
  { icon: 'icon-spinner6', free: true },
  { icon: 'icon-spinner7', free: true },
  { icon: 'icon-spinner8', free: true },
  { icon: 'icon-spinner9', free: true },
  { icon: 'icon-spinner10', free: true },
  { icon: 'icon-spinner11', free: true },
  { icon: 'icon-microscope' },
  { icon: 'icon-binoculars', free: true },
  { icon: 'icon-binoculars2' },
  { icon: 'icon-search', free: true },
  { icon: 'icon-zoom-in', free: true },
  { icon: 'icon-zoom-out', free: true },
  { icon: 'icon-search2' },
  { icon: 'icon-zoom-in2' },
  { icon: 'icon-zoom-out2' },
  { icon: 'icon-search3' },
  { icon: 'icon-search4' },
  { icon: 'icon-zoom-in3' },
  { icon: 'icon-zoom-out3' },
  { icon: 'icon-search5' },
  { icon: 'icon-search6' },
  { icon: 'icon-enlarge', free: true },
  { icon: 'icon-shrink', free: true },
  { icon: 'icon-enlarge2', free: true },
  { icon: 'icon-shrink2', free: true },
  { icon: 'icon-enlarge3' },
  { icon: 'icon-shrink3' },
  { icon: 'icon-enlarge4' },
  { icon: 'icon-shrink4' },
  { icon: 'icon-enlarge5' },
  { icon: 'icon-shrink5' },
  { icon: 'icon-enlarge6' },
  { icon: 'icon-shrink6' },
  { icon: 'icon-enlarge7' },
  { icon: 'icon-shrink7' },
  { icon: 'icon-key', free: true },
  { icon: 'icon-key2', free: true },
  { icon: 'icon-key3' },
  { icon: 'icon-key4' },
  { icon: 'icon-key5' },
  { icon: 'icon-keyhole' },
  { icon: 'icon-lock', free: true },
  { icon: 'icon-lock2' },
  { icon: 'icon-lock3' },
  { icon: 'icon-lock4' },
  { icon: 'icon-unlocked', free: true },
  { icon: 'icon-lock5' },
  { icon: 'icon-unlocked2' },
  { icon: 'icon-safe' },
  { icon: 'icon-wrench', free: true },
  { icon: 'icon-wrench2' },
  { icon: 'icon-wrench3' },
  { icon: 'icon-equalizer', free: true },
  { icon: 'icon-equalizer2', free: true },
  { icon: 'icon-equalizer3' },
  { icon: 'icon-equalizer4' },
  { icon: 'icon-cog', free: true },
  { icon: 'icon-cogs', free: true },
  { icon: 'icon-cog2' },
  { icon: 'icon-cog3' },
  { icon: 'icon-cog4' },
  { icon: 'icon-cog5' },
  { icon: 'icon-cog6' },
  { icon: 'icon-cog7' },
  { icon: 'icon-factory' },
  { icon: 'icon-hammer', free: true },
  { icon: 'icon-hammer-wrench' },
  { icon: 'icon-knife' },
  { icon: 'icon-screwdriver' },
  { icon: 'icon-screwdriver2' },
  { icon: 'icon-magic-wand', free: true },
  { icon: 'icon-magic-wand2' },
  { icon: 'icon-pulse' },
  { icon: 'icon-pulse2' },
  { icon: 'icon-aid-kit', free: true },
  { icon: 'icon-aid-kit2' },
  { icon: 'icon-stethoscope' },
  { icon: 'icon-ambulance' },
  { icon: 'icon-alarm2' },
  { icon: 'icon-pandage' },
  { icon: 'icon-pandage2' },
  { icon: 'icon-bug', free: true },
  { icon: 'icon-bug2' },
  { icon: 'icon-syringe' },
  { icon: 'icon-syringe2' },
  { icon: 'icon-pill' },
  { icon: 'icon-construction' },
  { icon: 'icon-traffic-cone' },
  { icon: 'icon-traffic-lights' },
  { icon: 'icon-pie-chart', free: true },
  { icon: 'icon-pie-chart2' },
  { icon: 'icon-pie-chart3' },
  { icon: 'icon-pie-chart4' },
  { icon: 'icon-pie-chart5' },
  { icon: 'icon-pie-chart6' },
  { icon: 'icon-pie-chart7' },
  { icon: 'icon-stats-dots', free: true },
  { icon: 'icon-stats-bars', free: true },
  { icon: 'icon-pie-chart8' },
  { icon: 'icon-stats-bars2', free: true },
  { icon: 'icon-stats-bars3' },
  { icon: 'icon-stats-bars4' },
  { icon: 'icon-stats-bars5' },
  { icon: 'icon-stats-bars6' },
  { icon: 'icon-chart' },
  { icon: 'icon-stats-growth' },
  { icon: 'icon-stats-decline' },
  { icon: 'icon-stats-growth2' },
  { icon: 'icon-stats-decline2' },
  { icon: 'icon-stairs-up' },
  { icon: 'icon-stairs-down' },
  { icon: 'icon-stairs' },
  { icon: 'icon-stairs2' },
  { icon: 'icon-ladder' },
  { icon: 'icon-rating' },
  { icon: 'icon-rating2' },
  { icon: 'icon-rating3' },
  { icon: 'icon-cake' },
  { icon: 'icon-podium' },
  { icon: 'icon-stars' },
  { icon: 'icon-medal-star' },
  { icon: 'icon-medal' },
  { icon: 'icon-medal2' },
  { icon: 'icon-medal-first' },
  { icon: 'icon-medal-second' },
  { icon: 'icon-medal-third' },
  { icon: 'icon-crown' },
  { icon: 'icon-trophy', free: true },
  { icon: 'icon-trophy2' },
  { icon: 'icon-trophy3' },
  { icon: 'icon-diamond' },
  { icon: 'icon-diamond2' },
  { icon: 'icon-trophy4' },
  { icon: 'icon-gift', free: true },
  { icon: 'icon-gift2' },
  { icon: 'icon-balloon' },
  { icon: 'icon-pipe' },
  { icon: 'icon-mustache' },
  { icon: 'icon-mustache2' },
  { icon: 'icon-glass', free: true },
  { icon: 'icon-glass2', free: true },
  { icon: 'icon-glass3' },
  { icon: 'icon-glass4' },
  { icon: 'icon-bottle' },
  { icon: 'icon-bottle2' },
  { icon: 'icon-bottle3' },
  { icon: 'icon-bottle4' },
  { icon: 'icon-mug', free: true },
  { icon: 'icon-fork-knife' },
  { icon: 'icon-spoon-knife', free: true },
  { icon: 'icon-cook' },
  { icon: 'icon-plate' },
  { icon: 'icon-steak' },
  { icon: 'icon-fish' },
  { icon: 'icon-chicken' },
  { icon: 'icon-hamburger' },
  { icon: 'icon-pizza' },
  { icon: 'icon-cheese' },
  { icon: 'icon-bread' },
  { icon: 'icon-icecream' },
  { icon: 'icon-milk' },
  { icon: 'icon-cup' },
  { icon: 'icon-cup2' },
  { icon: 'icon-coffee-bean' },
  { icon: 'icon-coffee' },
  { icon: 'icon-teapot' },
  { icon: 'icon-leaf', free: true },
  { icon: 'icon-leaf2' },
  { icon: 'icon-apple' },
  { icon: 'icon-grapes' },
  { icon: 'icon-cherry' },
  { icon: 'icon-tree', free: true },
  { icon: 'icon-tree2' },
  { icon: 'icon-tree3' },
  { icon: 'icon-tree4' },
  { icon: 'icon-cactus' },
  { icon: 'icon-mountains' },
  { icon: 'icon-paw' },
  { icon: 'icon-footprint' },
  { icon: 'icon-tent' },
  { icon: 'icon-flower' },
  { icon: 'icon-flower2' },
  { icon: 'icon-rocket', free: true },
  { icon: 'icon-meter', free: true },
  { icon: 'icon-meter2', free: true },
  { icon: 'icon-meter-slow' },
  { icon: 'icon-meter-medium' },
  { icon: 'icon-meter-fast' },
  { icon: 'icon-meter3' },
  { icon: 'icon-hammer2', free: true },
  { icon: 'icon-balance' },
  { icon: 'icon-scale' },
  { icon: 'icon-bomb' },
  { icon: 'icon-fire', free: true },
  { icon: 'icon-fire2' },
  { icon: 'icon-lab', free: true },
  { icon: 'icon-atom' },
  { icon: 'icon-atom2' },
  { icon: 'icon-magnet', free: true },
  { icon: 'icon-magnet2' },
  { icon: 'icon-dumbbell' },
  { icon: 'icon-skull' },
  { icon: 'icon-skull2' },
  { icon: 'icon-lamp' },
  { icon: 'icon-lamp2' },
  { icon: 'icon-lamp3' },
  { icon: 'icon-spotlight' },
  { icon: 'icon-lamp4' },
  { icon: 'icon-lamp5' },
  { icon: 'icon-lamp6' },
  { icon: 'icon-lamp7' },
  { icon: 'icon-lamp8' },
  { icon: 'icon-broom' },
  { icon: 'icon-toiletpaper' },
  { icon: 'icon-bin', free: true },
  { icon: 'icon-bin2', free: true },
  { icon: 'icon-bin3' },
  { icon: 'icon-bin4' },
  { icon: 'icon-bin5' },
  { icon: 'icon-briefcase', free: true },
  { icon: 'icon-briefcase2' },
  { icon: 'icon-briefcase3' },
  { icon: 'icon-airplane', free: true },
  { icon: 'icon-airplane2' },
  { icon: 'icon-airplane3' },
  { icon: 'icon-airplane4' },
  { icon: 'icon-paperplane' },
  { icon: 'icon-car' },
  { icon: 'icon-steering-wheel' },
  { icon: 'icon-car2' },
  { icon: 'icon-gas' },
  { icon: 'icon-bus' },
  { icon: 'icon-truck', free: true },
  { icon: 'icon-bike' },
  { icon: 'icon-road', free: true },
  { icon: 'icon-train' },
  { icon: 'icon-train2' },
  { icon: 'icon-ship' },
  { icon: 'icon-boat' },
  { icon: 'icon-chopper' },
  { icon: 'icon-chopper2' },
  { icon: 'icon-cube' },
  { icon: 'icon-cube2' },
  { icon: 'icon-cube3' },
  { icon: 'icon-cube4' },
  { icon: 'icon-pyramid' },
  { icon: 'icon-pyramid2' },
  { icon: 'icon-package' },
  { icon: 'icon-puzzle' },
  { icon: 'icon-puzzle2' },
  { icon: 'icon-puzzle3' },
  { icon: 'icon-puzzle4' },
  { icon: 'icon-glasses-3d' },
  { icon: 'icon-glasses-3d2' },
  { icon: 'icon-glasses' },
  { icon: 'icon-glasses2' },
  { icon: 'icon-brain' },
  { icon: 'icon-accessibility', free: true },
  { icon: 'icon-accessibility2' },
  { icon: 'icon-strategy' },
  { icon: 'icon-target', free: true },
  { icon: 'icon-target2' },
  { icon: 'icon-target3' },
  { icon: 'icon-ammo' },
  { icon: 'icon-gun' },
  { icon: 'icon-gun-forbidden' },
  { icon: 'icon-shield', free: true },
  { icon: 'icon-shield-check' },
  { icon: 'icon-shield-notice' },
  { icon: 'icon-shield2' },
  { icon: 'icon-shield3' },
  { icon: 'icon-shield4' },
  { icon: 'icon-soccer' },
  { icon: 'icon-football' },
  { icon: 'icon-archery' },
  { icon: 'icon-bow' },
  { icon: 'icon-sword' },
  { icon: 'icon-tennis' },
  { icon: 'icon-pingpong' },
  { icon: 'icon-baseball' },
  { icon: 'icon-basketball' },
  { icon: 'icon-golf' },
  { icon: 'icon-golf2' },
  { icon: 'icon-hockey' },
  { icon: 'icon-racing' },
  { icon: 'icon-finish' },
  { icon: 'icon-eight-ball' },
  { icon: 'icon-bowling' },
  { icon: 'icon-bowling2' },
  { icon: 'icon-power', free: true },
  { icon: 'icon-power2' },
  { icon: 'icon-power3' },
  { icon: 'icon-switch', free: true },
  { icon: 'icon-switch2' },
  { icon: 'icon-power-cord', free: true },
  { icon: 'icon-power-cord2' },
  { icon: 'icon-outlet' },
  { icon: 'icon-clipboard', free: true },
  { icon: 'icon-clipboard2' },
  { icon: 'icon-clipboard3' },
  { icon: 'icon-clipboard4' },
  { icon: 'icon-clipboard5' },
  { icon: 'icon-clipboard6' },
  { icon: 'icon-playlist' },
  { icon: 'icon-playlist-add' },
  { icon: 'icon-list-numbered', free: true },
  { icon: 'icon-list', free: true },
  { icon: 'icon-list2', free: true },
  { icon: 'icon-more' },
  { icon: 'icon-more2' },
  { icon: 'icon-grid' },
  { icon: 'icon-grid2' },
  { icon: 'icon-grid3' },
  { icon: 'icon-grid4' },
  { icon: 'icon-grid5' },
  { icon: 'icon-grid6' },
  { icon: 'icon-grid7' },
  { icon: 'icon-tree5' },
  { icon: 'icon-tree6' },
  { icon: 'icon-tree7' },
  { icon: 'icon-lan' },
  { icon: 'icon-lan2' },
  { icon: 'icon-lan3' },
  { icon: 'icon-menu', free: true },
  { icon: 'icon-circle-small' },
  { icon: 'icon-menu2', free: true },
  { icon: 'icon-menu3', free: true },
  { icon: 'icon-menu4', free: true },
  { icon: 'icon-menu5' },
  { icon: 'icon-menu6' },
  { icon: 'icon-menu7' },
  { icon: 'icon-menu8' },
  { icon: 'icon-menu9' },
  { icon: 'icon-menu10' },
  { icon: 'icon-cloud', free: true },
  { icon: 'icon-cloud-download', free: true },
  { icon: 'icon-cloud-upload', free: true },
  { icon: 'icon-cloud-check', free: true },
  { icon: 'icon-cloud2' },
  { icon: 'icon-cloud-download2' },
  { icon: 'icon-cloud-upload2' },
  { icon: 'icon-cloud-check2' },
  { icon: 'icon-download2', free: true },
  { icon: 'icon-download3', free: true },
  { icon: 'icon-upload2', free: true },
  { icon: 'icon-upload3', free: true },
  { icon: 'icon-import' },
  { icon: 'icon-import2' },
  { icon: 'icon-download4' },
  { icon: 'icon-upload4' },
  { icon: 'icon-download5' },
  { icon: 'icon-upload5' },
  { icon: 'icon-download6' },
  { icon: 'icon-upload6' },
  { icon: 'icon-download7' },
  { icon: 'icon-upload7' },
  { icon: 'icon-download8' },
  { icon: 'icon-upload8' },
  { icon: 'icon-download9' },
  { icon: 'icon-upload9' },
  { icon: 'icon-download10' },
  { icon: 'icon-upload10' },
  { icon: 'icon-sphere', free: true },
  { icon: 'icon-sphere2' },
  { icon: 'icon-sphere3' },
  { icon: 'icon-planet' },
  { icon: 'icon-planet2' },
  { icon: 'icon-earth', free: true },
  { icon: 'icon-earth2' },
  { icon: 'icon-earth3' },
  { icon: 'icon-link', free: true },
  { icon: 'icon-unlink' },
  { icon: 'icon-link2' },
  { icon: 'icon-unlink2' },
  { icon: 'icon-link3' },
  { icon: 'icon-unlink3' },
  { icon: 'icon-link4' },
  { icon: 'icon-unlink4' },
  { icon: 'icon-link5' },
  { icon: 'icon-unlink5' },
  { icon: 'icon-anchor' },
  { icon: 'icon-flag', free: true },
  { icon: 'icon-flag2' },
  { icon: 'icon-flag3' },
  { icon: 'icon-flag4' },
  { icon: 'icon-flag5' },
  { icon: 'icon-flag6' },
  { icon: 'icon-flag7' },
  { icon: 'icon-flag8' },
  { icon: 'icon-attachment', free: true },
  { icon: 'icon-attachment2' },
  { icon: 'icon-eye', free: true },
  { icon: 'icon-eye-plus', free: true },
  { icon: 'icon-eye-minus', free: true },
  { icon: 'icon-eye-blocked', free: true },
  { icon: 'icon-eye2' },
  { icon: 'icon-eye-blocked2' },
  { icon: 'icon-eye3' },
  { icon: 'icon-eye-blocked3' },
  { icon: 'icon-eye4' },
  { icon: 'icon-bookmark2' },
  { icon: 'icon-bookmark3' },
  { icon: 'icon-bookmarks', free: true },
  { icon: 'icon-bookmark4' },
  { icon: 'icon-spotlight2' },
  { icon: 'icon-starburst' },
  { icon: 'icon-snowflake' },
  { icon: 'icon-temperature' },
  { icon: 'icon-temperature2' },
  { icon: 'icon-weather-lightning' },
  { icon: 'icon-weather-lightning2' },
  { icon: 'icon-weather-rain' },
  { icon: 'icon-weather-rain2' },
  { icon: 'icon-weather-snow' },
  { icon: 'icon-weather-snow2' },
  { icon: 'icon-weather-cloud-wind' },
  { icon: 'icon-weather-cloud-wind2' },
  { icon: 'icon-weather-cloud-sun' },
  { icon: 'icon-weather-cloud-sun2' },
  { icon: 'icon-weather-cloudy' },
  { icon: 'icon-weather-cloudy2' },
  { icon: 'icon-weather-sun-wind' },
  { icon: 'icon-weather-sun-wind2' },
  { icon: 'icon-sun', free: true },
  { icon: 'icon-sun2' },
  { icon: 'icon-moon' },
  { icon: 'icon-day-night' },
  { icon: 'icon-day-night2' },
  { icon: 'icon-weather-windy' },
  { icon: 'icon-fan' },
  { icon: 'icon-umbrella' },
  { icon: 'icon-sun3' },
  { icon: 'icon-contrast', free: true },
  { icon: 'icon-brightness-contrast', free: true },
  { icon: 'icon-brightness-high' },
  { icon: 'icon-brightness-medium' },
  { icon: 'icon-brightness-low' },
  { icon: 'icon-bed' },
  { icon: 'icon-bed2' },
  { icon: 'icon-furniture' },
  { icon: 'icon-chair' },
  { icon: 'icon-star-empty', free: true },
  { icon: 'icon-star-empty2' },
  { icon: 'icon-star-full', free: true },
  { icon: 'icon-star-empty3' },
  { icon: 'icon-star-half', free: true },
  { icon: 'icon-star-full2' },
  { icon: 'icon-star' },
  { icon: 'icon-heart', free: true },
  { icon: 'icon-heart2' },
  { icon: 'icon-heart3' },
  { icon: 'icon-heart4' },
  { icon: 'icon-heart-broken', free: true },
  { icon: 'icon-heart5' },
  { icon: 'icon-heart6' },
  { icon: 'icon-heart-broken2' },
  { icon: 'icon-heart7' },
  { icon: 'icon-heart8' },
  { icon: 'icon-heart-broken3' },
  { icon: 'icon-lips' },
  { icon: 'icon-lips2' },
  { icon: 'icon-thumbs-up' },
  { icon: 'icon-thumbs-up2' },
  { icon: 'icon-thumbs-down' },
  { icon: 'icon-thumbs-down2' },
  { icon: 'icon-thumbs-up3' },
  { icon: 'icon-thumbs-down3' },
  { icon: 'icon-height' },
  { icon: 'icon-man', free: true },
  { icon: 'icon-woman', free: true },
  { icon: 'icon-man-woman', free: true },
  { icon: 'icon-male' },
  { icon: 'icon-female' },
  { icon: 'icon-peace' },
  { icon: 'icon-yin-yang' },
  { icon: 'icon-happy', free: true },
  { icon: 'icon-happy2', free: true },
  { icon: 'icon-smile', free: true },
  { icon: 'icon-smile2', free: true },
  { icon: 'icon-tongue', free: true },
  { icon: 'icon-tongue2', free: true },
  { icon: 'icon-sad', free: true },
  { icon: 'icon-sad2', free: true },
  { icon: 'icon-wink', free: true },
  { icon: 'icon-wink2', free: true },
  { icon: 'icon-grin', free: true },
  { icon: 'icon-grin2', free: true },
  { icon: 'icon-cool', free: true },
  { icon: 'icon-cool2', free: true },
  { icon: 'icon-angry', free: true },
  { icon: 'icon-angry2', free: true },
  { icon: 'icon-evil', free: true },
  { icon: 'icon-evil2', free: true },
  { icon: 'icon-shocked', free: true },
  { icon: 'icon-shocked2', free: true },
  { icon: 'icon-baffled', free: true },
  { icon: 'icon-baffled2', free: true },
  { icon: 'icon-confused', free: true },
  { icon: 'icon-confused2', free: true },
  { icon: 'icon-neutral', free: true },
  { icon: 'icon-neutral2', free: true },
  { icon: 'icon-hipster', free: true },
  { icon: 'icon-hipster2', free: true },
  { icon: 'icon-wondering', free: true },
  { icon: 'icon-wondering2', free: true },
  { icon: 'icon-sleepy', free: true },
  { icon: 'icon-sleepy2', free: true },
  { icon: 'icon-frustrated', free: true },
  { icon: 'icon-frustrated2', free: true },
  { icon: 'icon-crying', free: true },
  { icon: 'icon-crying2', free: true },
  { icon: 'icon-cursor' },
  { icon: 'icon-cursor2' },
  { icon: 'icon-lasso' },
  { icon: 'icon-lasso2' },
  { icon: 'icon-select' },
  { icon: 'icon-select2' },
  { icon: 'icon-point-up', free: true },
  { icon: 'icon-point-right', free: true },
  { icon: 'icon-point-down', free: true },
  { icon: 'icon-point-left', free: true },
  { icon: 'icon-pointer' },
  { icon: 'icon-reminder' },
  { icon: 'icon-drag-left-right' },
  { icon: 'icon-drag-left' },
  { icon: 'icon-drag-right' },
  { icon: 'icon-touch' },
  { icon: 'icon-multitouch' },
  { icon: 'icon-touch-zoom' },
  { icon: 'icon-touch-pinch' },
  { icon: 'icon-hand' },
  { icon: 'icon-grab' },
  { icon: 'icon-stack-empty' },
  { icon: 'icon-stack-plus' },
  { icon: 'icon-stack-minus' },
  { icon: 'icon-stack-star' },
  { icon: 'icon-stack-picture' },
  { icon: 'icon-stack-down' },
  { icon: 'icon-stack-up' },
  { icon: 'icon-stack-cancel' },
  { icon: 'icon-stack-check' },
  { icon: 'icon-stack-text' },
  { icon: 'icon-stack-clubs' },
  { icon: 'icon-stack-spades' },
  { icon: 'icon-stack-hearts' },
  { icon: 'icon-stack-diamonds' },
  { icon: 'icon-stack-user' },
  { icon: 'icon-stack4' },
  { icon: 'icon-stack-music' },
  { icon: 'icon-stack-play' },
  { icon: 'icon-move' },
  { icon: 'icon-dots' },
  { icon: 'icon-warning', free: true },
  { icon: 'icon-warning2' },
  { icon: 'icon-notification', free: true },
  { icon: 'icon-notification2' },
  { icon: 'icon-question', free: true },
  { icon: 'icon-question2' },
  { icon: 'icon-question3' },
  { icon: 'icon-question4' },
  { icon: 'icon-question5' },
  { icon: 'icon-question6' },
  { icon: 'icon-plus', free: true },
  { icon: 'icon-minus', free: true },
  { icon: 'icon-plus2' },
  { icon: 'icon-minus2' },
  { icon: 'icon-plus3' },
  { icon: 'icon-minus3' },
  { icon: 'icon-plus-circle' },
  { icon: 'icon-minus-circle' },
  { icon: 'icon-plus-circle2' },
  { icon: 'icon-minus-circle2' },
  { icon: 'icon-info', free: true },
  { icon: 'icon-info2' },
  { icon: 'icon-cancel-circle', free: true },
  { icon: 'icon-cancel-circle2' },
  { icon: 'icon-blocked', free: true },
  { icon: 'icon-cancel-square' },
  { icon: 'icon-cancel-square2' },
  { icon: 'icon-cancel' },
  { icon: 'icon-spam' },
  { icon: 'icon-cross', free: true },
  { icon: 'icon-cross2' },
  { icon: 'icon-cross3' },
  { icon: 'icon-checkmark', free: true },
  { icon: 'icon-checkmark2', free: true },
  { icon: 'icon-checkmark3' },
  { icon: 'icon-checkmark4' },
  { icon: 'icon-checkmark5' },
  { icon: 'icon-spell-check', free: true },
  { icon: 'icon-spell-check2' },
  { icon: 'icon-enter', free: true },
  { icon: 'icon-exit', free: true },
  { icon: 'icon-enter2' },
  { icon: 'icon-exit2' },
  { icon: 'icon-enter3' },
  { icon: 'icon-exit3' },
  { icon: 'icon-wall' },
  { icon: 'icon-fence' },
  { icon: 'icon-play3', free: true },
  { icon: 'icon-pause', free: true },
  { icon: 'icon-stop', free: true },
  { icon: 'icon-previous', free: true },
  { icon: 'icon-next', free: true },
  { icon: 'icon-backward', free: true },
  { icon: 'icon-forward2', free: true },
  { icon: 'icon-play4' },
  { icon: 'icon-pause2', free: true },
  { icon: 'icon-stop2', free: true },
  { icon: 'icon-backward2', free: true },
  { icon: 'icon-forward3', free: true },
  { icon: 'icon-first', free: true },
  { icon: 'icon-last', free: true },
  { icon: 'icon-previous2', free: true },
  { icon: 'icon-next2', free: true },
  { icon: 'icon-eject', free: true },
  { icon: 'icon-volume-high', free: true },
  { icon: 'icon-volume-medium', free: true },
  { icon: 'icon-volume-low', free: true },
  { icon: 'icon-volume-mute', free: true },
  { icon: 'icon-speaker-left' },
  { icon: 'icon-speaker-right' },
  { icon: 'icon-volume-mute2', free: true },
  { icon: 'icon-volume-increase', free: true },
  { icon: 'icon-volume-decrease', free: true },
  { icon: 'icon-volume-high2' },
  { icon: 'icon-volume-medium2' },
  { icon: 'icon-volume-medium3' },
  { icon: 'icon-volume-low2' },
  { icon: 'icon-volume-mute3' },
  { icon: 'icon-volume-increase2' },
  { icon: 'icon-volume-decrease2' },
  { icon: 'icon-volume-decrease3' },
  { icon: 'icon-volume-5' },
  { icon: 'icon-volume-4' },
  { icon: 'icon-volume-3' },
  { icon: 'icon-volume-2' },
  { icon: 'icon-volume-1' },
  { icon: 'icon-volume-0' },
  { icon: 'icon-volume-mute4' },
  { icon: 'icon-volume-mute5' },
  { icon: 'icon-loop', free: true },
  { icon: 'icon-loop2', free: true },
  { icon: 'icon-loop3' },
  { icon: 'icon-infinite-square' },
  { icon: 'icon-infinite', free: true },
  { icon: 'icon-infinite2' },
  { icon: 'icon-loop4' },
  { icon: 'icon-shuffle', free: true },
  { icon: 'icon-shuffle2' },
  { icon: 'icon-wave' },
  { icon: 'icon-wave2' },
  { icon: 'icon-split' },
  { icon: 'icon-merge' },
  { icon: 'icon-first2' },
  { icon: 'icon-last2' },
  { icon: 'icon-arrow-up', free: true },
  { icon: 'icon-arrow-up2', free: true },
  { icon: 'icon-arrow-up3' },
  { icon: 'icon-arrow-up4' },
  { icon: 'icon-arrow-right', free: true },
  { icon: 'icon-arrow-right2', free: true },
  { icon: 'icon-arrow-right3' },
  { icon: 'icon-arrow-right4' },
  { icon: 'icon-arrow-down', free: true },
  { icon: 'icon-arrow-down2', free: true },
  { icon: 'icon-arrow-down3' },
  { icon: 'icon-arrow-down4' },
  { icon: 'icon-arrow-left', free: true },
  { icon: 'icon-arrow-left2', free: true },
  { icon: 'icon-arrow-left3' },
  { icon: 'icon-arrow-left4' },
  { icon: 'icon-arrow-up5' },
  { icon: 'icon-arrow-right5' },
  { icon: 'icon-arrow-down5' },
  { icon: 'icon-arrow-left5' },
  { icon: 'icon-arrow-up-left', free: true },
  { icon: 'icon-arrow-up6' },
  { icon: 'icon-arrow-up-right', free: true },
  { icon: 'icon-arrow-right6' },
  { icon: 'icon-arrow-down-right', free: true },
  { icon: 'icon-arrow-down6' },
  { icon: 'icon-arrow-down-left', free: true },
  { icon: 'icon-arrow-left6' },
  { icon: 'icon-arrow-up-left2', free: true },
  { icon: 'icon-arrow-up7' },
  { icon: 'icon-arrow-up-right2', free: true },
  { icon: 'icon-arrow-right7' },
  { icon: 'icon-arrow-down-right2', free: true },
  { icon: 'icon-arrow-down7' },
  { icon: 'icon-arrow-down-left2', free: true },
  { icon: 'icon-arrow-left7' },
  { icon: 'icon-arrow-up-left3' },
  { icon: 'icon-arrow-up8' },
  { icon: 'icon-arrow-up-right3' },
  { icon: 'icon-arrow-right8' },
  { icon: 'icon-arrow-down-right3' },
  { icon: 'icon-arrow-down8' },
  { icon: 'icon-arrow-down-left3' },
  { icon: 'icon-arrow-left8' },
  { icon: 'icon-circle-up', free: true },
  { icon: 'icon-circle-right', free: true },
  { icon: 'icon-circle-down', free: true },
  { icon: 'icon-circle-left', free: true },
  { icon: 'icon-circle-up2' },
  { icon: 'icon-circle-right2' },
  { icon: 'icon-circle-down2' },
  { icon: 'icon-circle-left2' },
  { icon: 'icon-circle-up-left' },
  { icon: 'icon-circle-up3' },
  { icon: 'icon-circle-up-right' },
  { icon: 'icon-circle-right3' },
  { icon: 'icon-circle-down-right' },
  { icon: 'icon-circle-down3' },
  { icon: 'icon-circle-down-left' },
  { icon: 'icon-circle-left3' },
  { icon: 'icon-circle-up-left2' },
  { icon: 'icon-circle-up4' },
  { icon: 'icon-circle-up-right2' },
  { icon: 'icon-circle-right4' },
  { icon: 'icon-circle-down-right2' },
  { icon: 'icon-circle-down4' },
  { icon: 'icon-circle-down-left2' },
  { icon: 'icon-circle-left4' },
  { icon: 'icon-arrow-resize' },
  { icon: 'icon-arrow-resize2' },
  { icon: 'icon-arrow-resize3' },
  { icon: 'icon-arrow-resize4' },
  { icon: 'icon-arrow-resize5' },
  { icon: 'icon-arrow-resize6' },
  { icon: 'icon-arrow-resize7' },
  { icon: 'icon-arrow-resize8' },
  { icon: 'icon-square-up-left' },
  { icon: 'icon-square-up' },
  { icon: 'icon-square-up-right' },
  { icon: 'icon-square-right' },
  { icon: 'icon-square-down-right' },
  { icon: 'icon-square-down' },
  { icon: 'icon-square-down-left' },
  { icon: 'icon-square-left' },
  { icon: 'icon-arrow-up9' },
  { icon: 'icon-arrow-right9' },
  { icon: 'icon-arrow-down9' },
  { icon: 'icon-arrow-left9' },
  { icon: 'icon-arrow-up10' },
  { icon: 'icon-arrow-right10' },
  { icon: 'icon-arrow-down10' },
  { icon: 'icon-arrow-left10' },
  { icon: 'icon-arrow-up-left4' },
  { icon: 'icon-arrow-up11' },
  { icon: 'icon-arrow-up-right4' },
  { icon: 'icon-arrow-right11' },
  { icon: 'icon-arrow-down-right4' },
  { icon: 'icon-arrow-down11' },
  { icon: 'icon-arrow-down-left4' },
  { icon: 'icon-arrow-left11' },
  { icon: 'icon-arrow-up-left5' },
  { icon: 'icon-arrow-up12' },
  { icon: 'icon-arrow-up-right5' },
  { icon: 'icon-arrow-right12' },
  { icon: 'icon-arrow-down-right5' },
  { icon: 'icon-arrow-down12' },
  { icon: 'icon-arrow-down-left5' },
  { icon: 'icon-arrow-left12' },
  { icon: 'icon-arrow-up13' },
  { icon: 'icon-arrow-right13' },
  { icon: 'icon-arrow-down13' },
  { icon: 'icon-arrow-left13' },
  { icon: 'icon-arrow-up14' },
  { icon: 'icon-arrow-right14' },
  { icon: 'icon-arrow-down14' },
  { icon: 'icon-arrow-left14' },
  { icon: 'icon-circle-up5' },
  { icon: 'icon-circle-right5' },
  { icon: 'icon-circle-down5' },
  { icon: 'icon-circle-left5' },
  { icon: 'icon-circle-up6' },
  { icon: 'icon-circle-right6' },
  { icon: 'icon-circle-down6' },
  { icon: 'icon-circle-left6' },
  { icon: 'icon-arrow-up15' },
  { icon: 'icon-arrow-right15' },
  { icon: 'icon-arrow-down15' },
  { icon: 'icon-arrow-left15' },
  { icon: 'icon-arrow-up16' },
  { icon: 'icon-arrow-right16' },
  { icon: 'icon-arrow-down16' },
  { icon: 'icon-arrow-left16' },
  { icon: 'icon-menu-open' },
  { icon: 'icon-menu-open2' },
  { icon: 'icon-menu-close' },
  { icon: 'icon-menu-close2' },
  { icon: 'icon-enter4' },
  { icon: 'icon-enter5' },
  { icon: 'icon-esc' },
  { icon: 'icon-enter6' },
  { icon: 'icon-backspace' },
  { icon: 'icon-backspace2' },
  { icon: 'icon-tab', free: true },
  { icon: 'icon-transmission' },
  { icon: 'icon-transmission2' },
  { icon: 'icon-sort' },
  { icon: 'icon-sort2' },
  { icon: 'icon-move-up', free: true },
  { icon: 'icon-move-down', free: true },
  { icon: 'icon-sort-alpha-asc', free: true },
  { icon: 'icon-sort-alpha-desc', free: true },
  { icon: 'icon-sort-numeric-asc', free: true },
  { icon: 'icon-sort-numberic-desc', free: true },
  { icon: 'icon-sort-amount-asc', free: true },
  { icon: 'icon-sort-amount-desc', free: true },
  { icon: 'icon-sort-time-asc' },
  { icon: 'icon-sort-time-desc' },
  { icon: 'icon-battery-6' },
  { icon: 'icon-battery-5' },
  { icon: 'icon-battery-4' },
  { icon: 'icon-battery-3' },
  { icon: 'icon-battery-2' },
  { icon: 'icon-battery-1' },
  { icon: 'icon-battery-0' },
  { icon: 'icon-battery-charging' },
  { icon: 'icon-key-keyboard' },
  { icon: 'icon-key-A' },
  { icon: 'icon-key-up' },
  { icon: 'icon-key-right' },
  { icon: 'icon-key-down' },
  { icon: 'icon-key-left' },
  { icon: 'icon-command', free: true },
  { icon: 'icon-shift', free: true },
  { icon: 'icon-ctrl', free: true },
  { icon: 'icon-opt', free: true },
  { icon: 'icon-checkbox-checked', free: true },
  { icon: 'icon-checkbox-unchecked', free: true },
  { icon: 'icon-checkbox-partial' },
  { icon: 'icon-square' },
  { icon: 'icon-triangle' },
  { icon: 'icon-triangle2' },
  { icon: 'icon-diamond3' },
  { icon: 'icon-diamond4' },
  { icon: 'icon-checkbox-checked2' },
  { icon: 'icon-checkbox-unchecked2' },
  { icon: 'icon-checkbox-partial2' },
  { icon: 'icon-radio-checked', free: true },
  { icon: 'icon-radio-checked2', free: true },
  { icon: 'icon-radio-unchecked', free: true },
  { icon: 'icon-toggle-on' },
  { icon: 'icon-toggle-off' },
  { icon: 'icon-checkmark-circle' },
  { icon: 'icon-circle' },
  { icon: 'icon-circle2' },
  { icon: 'icon-circles' },
  { icon: 'icon-circles2' },
  { icon: 'icon-crop', free: true },
  { icon: 'icon-crop2' },
  { icon: 'icon-make-group', free: true },
  { icon: 'icon-ungroup', free: true },
  { icon: 'icon-vector' },
  { icon: 'icon-vector2' },
  { icon: 'icon-rulers' },
  { icon: 'icon-ruler' },
  { icon: 'icon-pencil-ruler' },
  { icon: 'icon-scissors', free: true },
  { icon: 'icon-scissors2' },
  { icon: 'icon-scissors3' },
  { icon: 'icon-haircut' },
  { icon: 'icon-comb' },
  { icon: 'icon-filter', free: true },
  { icon: 'icon-filter2' },
  { icon: 'icon-filter3' },
  { icon: 'icon-filter4' },
  { icon: 'icon-font', free: true },
  { icon: 'icon-ampersand' },
  { icon: 'icon-ligature', free: true },
  { icon: 'icon-ligature2', free: true },
  { icon: 'icon-font-size', free: true },
  { icon: 'icon-typography' },
  { icon: 'icon-text-height', free: true },
  { icon: 'icon-text-width', free: true },
  { icon: 'icon-height2' },
  { icon: 'icon-width' },
  { icon: 'icon-bold', free: true },
  { icon: 'icon-underline', free: true },
  { icon: 'icon-italic', free: true },
  { icon: 'icon-strikethrough', free: true },
  { icon: 'icon-strikethrough2' },
  { icon: 'icon-font-size2' },
  { icon: 'icon-bold2' },
  { icon: 'icon-underline2' },
  { icon: 'icon-italic2' },
  { icon: 'icon-strikethrough3' },
  { icon: 'icon-omega', free: true },
  { icon: 'icon-sigma', free: true },
  { icon: 'icon-nbsp' },
  { icon: 'icon-page-break', free: true },
  { icon: 'icon-page-break2' },
  { icon: 'icon-superscript', free: true },
  { icon: 'icon-subscript', free: true },
  { icon: 'icon-superscript2', free: true },
  { icon: 'icon-subscript2', free: true },
  { icon: 'icon-text-color', free: true },
  { icon: 'icon-highlight' },
  { icon: 'icon-pagebreak', free: true },
  { icon: 'icon-clear-formatting', free: true },
  { icon: 'icon-table', free: true },
  { icon: 'icon-table2', free: true },
  { icon: 'icon-insert-template', free: true },
  { icon: 'icon-pilcrow', free: true },
  { icon: 'icon-ltr', free: true },
  { icon: 'icon-rtl', free: true },
  { icon: 'icon-ltr2' },
  { icon: 'icon-rtl2' },
  { icon: 'icon-section', free: true },
  { icon: 'icon-paragraph-left', free: true },
  { icon: 'icon-paragraph-center', free: true },
  { icon: 'icon-paragraph-right', free: true },
  { icon: 'icon-paragraph-justify', free: true },
  { icon: 'icon-paragraph-left2' },
  { icon: 'icon-paragraph-center2' },
  { icon: 'icon-paragraph-right2' },
  { icon: 'icon-paragraph-justify2' },
  { icon: 'icon-indent-increase', free: true },
  { icon: 'icon-indent-decrease', free: true },
  { icon: 'icon-paragraph-left3' },
  { icon: 'icon-paragraph-center3' },
  { icon: 'icon-paragraph-right3' },
  { icon: 'icon-paragraph-justify3' },
  { icon: 'icon-indent-increase2' },
  { icon: 'icon-indent-decrease2' },
  { icon: 'icon-share', free: true },
  { icon: 'icon-share2', free: true },
  { icon: 'icon-new-tab', free: true },
  { icon: 'icon-new-tab2' },
  { icon: 'icon-popout' },
  { icon: 'icon-embed', free: true },
  { icon: 'icon-embed2', free: true },
  { icon: 'icon-markup' },
  { icon: 'icon-regexp' },
  { icon: 'icon-regexp2' },
  { icon: 'icon-code' },
  { icon: 'icon-circle-css' },
  { icon: 'icon-circle-code' },
  { icon: 'icon-terminal', free: true },
  { icon: 'icon-unicode' },
  { icon: 'icon-seven-segment-0' },
  { icon: 'icon-seven-segment-1' },
  { icon: 'icon-seven-segment-2' },
  { icon: 'icon-seven-segment-3' },
  { icon: 'icon-seven-segment-4' },
  { icon: 'icon-seven-segment-5' },
  { icon: 'icon-seven-segment-6' },
  { icon: 'icon-seven-segment-7' },
  { icon: 'icon-seven-segment-8' },
  { icon: 'icon-seven-segment-9' },
  { icon: 'icon-share3' },
  { icon: 'icon-share4' },
  { icon: 'icon-mail', free: true },
  { icon: 'icon-mail2', free: true },
  { icon: 'icon-mail3', free: true },
  { icon: 'icon-mail4', free: true },
  { icon: 'icon-amazon', free: true },
  { icon: 'icon-google', free: true },
  { icon: 'icon-google2', free: true },
  { icon: 'icon-google3', free: true },
  { icon: 'icon-google-plus', free: true },
  { icon: 'icon-google-plus2', free: true },
  { icon: 'icon-google-plus3', free: true },
  { icon: 'icon-hangouts', free: true },
  { icon: 'icon-google-drive', free: true },
  { icon: 'icon-facebook', free: true },
  { icon: 'icon-facebook2', free: true },
  { icon: 'icon-instagram', free: true },
  { icon: 'icon-whatsapp', free: true },
  { icon: 'icon-spotify', free: true },
  { icon: 'icon-telegram', free: true },
  { icon: 'icon-twitter', free: true },
  { icon: 'icon-vine', free: true },
  { icon: 'icon-vk', free: true },
  { icon: 'icon-renren', free: true },
  { icon: 'icon-sina-weibo', free: true },
  { icon: 'icon-rss', free: true },
  { icon: 'icon-rss2', free: true },
  { icon: 'icon-youtube', free: true },
  { icon: 'icon-twitch', free: true },
  { icon: 'icon-vimeo', free: true },
  { icon: 'icon-vimeo2', free: true },
  { icon: 'icon-lanyrd', free: true },
  { icon: 'icon-flickr', free: true },
  { icon: 'icon-flickr2', free: true },
  { icon: 'icon-flickr3', free: true },
  { icon: 'icon-flickr4', free: true },
  { icon: 'icon-dribbble', free: true },
  { icon: 'icon-behance', free: true },
  { icon: 'icon-behance2', free: true },
  { icon: 'icon-deviantart', free: true },
  { icon: 'icon-500px', free: true },
  { icon: 'icon-steam', free: true },
  { icon: 'icon-steam2', free: true },
  { icon: 'icon-dropbox', free: true },
  { icon: 'icon-onedrive', free: true },
  { icon: 'icon-github', free: true },
  { icon: 'icon-npm', free: true },
  { icon: 'icon-basecamp', free: true },
  { icon: 'icon-trello', free: true },
  { icon: 'icon-wordpress', free: true },
  { icon: 'icon-joomla', free: true },
  { icon: 'icon-ello', free: true },
  { icon: 'icon-blogger', free: true },
  { icon: 'icon-blogger2', free: true },
  { icon: 'icon-tumblr', free: true },
  { icon: 'icon-tumblr2', free: true },
  { icon: 'icon-yahoo', free: true },
  { icon: 'icon-yahoo2', free: true },
  { icon: 'icon-tux', free: true },
  { icon: 'icon-appleinc', free: true },
  { icon: 'icon-finder', free: true },
  { icon: 'icon-android', free: true },
  { icon: 'icon-windows', free: true },
  { icon: 'icon-windows8', free: true },
  { icon: 'icon-soundcloud', free: true },
  { icon: 'icon-soundcloud2', free: true },
  { icon: 'icon-skype', free: true },
  { icon: 'icon-reddit', free: true },
  { icon: 'icon-hackernews', free: true },
  { icon: 'icon-wikipedia', free: true },
  { icon: 'icon-linkedin', free: true },
  { icon: 'icon-linkedin2', free: true },
  { icon: 'icon-lastfm', free: true },
  { icon: 'icon-lastfm2', free: true },
  { icon: 'icon-delicious', free: true },
  { icon: 'icon-stumbleupon', free: true },
  { icon: 'icon-stumbleupon2', free: true },
  { icon: 'icon-stackoverflow', free: true },
  { icon: 'icon-pinterest', free: true },
  { icon: 'icon-pinterest2', free: true },
  { icon: 'icon-xing', free: true },
  { icon: 'icon-xing2', free: true },
  { icon: 'icon-flattr', free: true },
  { icon: 'icon-foursquare', free: true },
  { icon: 'icon-yelp', free: true },
  { icon: 'icon-paypal', free: true },
  { icon: 'icon-chrome', free: true },
  { icon: 'icon-firefox', free: true },
  { icon: 'icon-IE', free: true },
  { icon: 'icon-edge', free: true },
  { icon: 'icon-safari', free: true },
  { icon: 'icon-opera', free: true },
  { icon: 'icon-file-pdf', free: true },
  { icon: 'icon-file-openoffice', free: true },
  { icon: 'icon-file-word', free: true },
  { icon: 'icon-file-excel', free: true },
  { icon: 'icon-libreoffice', free: true },
  { icon: 'icon-html-five', free: true },
  { icon: 'icon-html-five2', free: true },
  { icon: 'icon-css3', free: true },
  { icon: 'icon-git', free: true },
  { icon: 'icon-codepen', free: true },
  { icon: 'icon-svg', free: true },
  { icon: 'icon-IcoMoon', free: true },
];
